<template>
  <v-data-table :headers="headers" :items="empVacations" :items-per-page="15">
    <template v-slot:[`item.cnfmYn`]="{ item }">
      <!-- {{ item.cnfmYn }} -->
      <template v-if="item.cnfmYn === 'Y'">
        확정
      </template>
      <template v-if="item.cnfmYn === 'N'">
        대기
        <v-btn
          rounded
          outlined
          small
          color="primary"
          class="ml-2"
          @click="onConfirm(item)"
          >확정</v-btn
        >
      </template>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: "휴가신청일",
          value: "planDt",
          width: "8%",
          align: "center",
        },
        {
          text: "휴가신청시간",
          value: "planTm",
          width: "8%",
          align: "center",
          sortable: false,
        },
        {
          text: "부서",
          value: "deptNm",
          width: "15%",
          align: "center",
          sortable: false,
        },
        {
          text: "직급",
          value: "empRank",
          width: "8%",
          align: "center",
          sortable: false,
        },
        {
          text: "이름",
          value: "empNm",
          width: "8%",
          align: "center",
        },
        {
          text: "신청휴가시간",
          value: "leaveRegTm",
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: "비고",
          value: "note",
          width: "13%",
          align: "center",
          sortable: false,
        },
        {
          text: "등록일",
          value: "regDtt",
          width: "10%",
          align: "center",
        },
        {
          text: "상태",
          value: "cnfmYn",
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: "확정일",
          value: "cnfmDt",
          width: "10%",
          align: "center",
        },
      ],
    };
  },
  props: ["empVacations"],
  methods: {
    onConfirm(item) {
      this.$emit("confirmVacation", item.empNo, item.planNo);
    },
  },
};
</script>

<style></style>
